import { createSlice } from '@reduxjs/toolkit';

// ** Initial State
const initialState = {
  billValidateData: {}
  // billValidateData: {
  //   NAME: {
  //     status: '',
  //     validation: '',
  //     modifiedValue: 'Chintamani Construction',
  //     originalValue: 'M/s. Chintamani Construction',
  //     answer: 'M/s. Chintamani Construction',
  //     accuracy: 99.94,
  //     label: 'Vendor Name',
  //     type: 'NAME',
  //     question: 'Is the Vendor Name correct?',
  //     comment: ''
  //   },
  //   VENDOR_GST_NUMBER: {
  //     status: '',
  //     validation: '',
  //     modifiedValue: '23ADVPT0814B1ZP',
  //     originalValue: '23ADVPT0814B1ZP',
  //     answer: '23ADVPT0814B1ZP',
  //     accuracy: 99.84,
  //     label: 'Vendor GST No.',
  //     type: 'VENDOR_GST_NUMBER',
  //     question: 'Is the Vendor GST No. correct?',
  //     comment: ''
  //   },
  //   TAX_PAYER_ID: {
  //     status: '',
  //     validation: '',
  //     modifiedValue: 'ADVPT0814B',
  //     originalValue: 'ADVPT0814B',
  //     answer: 'ADVPT0814B',
  //     accuracy: 99.94,
  //     label: 'PAN No.',
  //     type: 'TAX_PAYER_ID',
  //     question: 'Is the PAN No. correct?',
  //     comment: ''
  //   },
  //   ADDRESS: {
  //     status: '',
  //     validation: '',
  //     modifiedValue:
  //       'Chintamani Construction\n100, Manorma Colony, Near Shankar Mandir,Sagar,MP-470001',
  //     originalValue:
  //       'M/s. Chintamani Construction\n100, Manorma Colony, Near Shankar Mandir,Sagar,MP-470001',
  //     answer:
  //       'M/s. Chintamani Construction\n100, Manorma Colony, Near Shankar Mandir,Sagar,MP-470001',
  //     accuracy: 93.63,
  //     label: 'Vendor Address',
  //     type: 'ADDRESS',
  //     question: 'Is the Vendor Address correct?',
  //     comment: ''
  //   },
  //   RECEIVER_NAME: {
  //     status: '',
  //     validation: '',
  //     modifiedValue: 'M/s. Shreeji Infrastucture India PVT. Ltd.',
  //     originalValue: 'M/s. Shreeji Infrastucture India PVT. Ltd.',
  //     answer: 'M/s. Shreeji Infrastucture India PVT. Ltd.',
  //     accuracy: 99.08,
  //     label: 'Receiver Name',
  //     type: 'RECEIVER_NAME',
  //     question: 'Is the Receiver Name correct?',
  //     comment: ''
  //   },
  //   RECEIVER_GST_NUMBER: {
  //     status: '',
  //     validation: '',
  //     modifiedValue: '23AAGCS7898M1ZH',
  //     originalValue: '23AAGCS7898M1ZH',
  //     answer: '23AAGCS7898M1ZH',
  //     accuracy: 99.96,
  //     label: 'Receiver GST No.',
  //     type: 'RECEIVER_GST_NUMBER',
  //     question: 'Is the Receiver GST No. correct?',
  //     comment: ''
  //   },
  //   SUBTOTAL: {
  //     status: '',
  //     validation: '',
  //     modifiedValue: 705714.08,
  //     originalValue: 705714.08,
  //     answer: 705714.08,
  //     accuracy: 99.97,
  //     label: 'Taxable Value',
  //     type: 'SUBTOTAL',
  //     question: 'Is the Sub Total correct?',
  //     comment: ''
  //   },
  //   TAX1: {
  //     status: '',
  //     validation: '',
  //     modifiedValue: 63514,
  //     originalValue: 63514,
  //     answer: 63514,
  //     accuracy: 99.9,
  //     label: 'Add CGST @ 9%',
  //     type: 'TAX',
  //     question: 'Is the CGST correct?',
  //     comment: ''
  //   },
  //   TAX2: {
  //     status: '',
  //     validation: '',
  //     modifiedValue: 63514,
  //     originalValue: 63514,
  //     answer: 63514,
  //     accuracy: 99.88,
  //     label: 'Add SGST @ 9%',
  //     type: 'TAX',
  //     question: 'Is the SGST correct?',
  //     comment: ''
  //   },
  //   TAX3: {
  //     status: '',
  //     validation: '',
  //     modifiedValue: 'No Text Detected',
  //     originalValue: 'No Text Detected',
  //     answer: 'No Text Detected',
  //     accuracy: 0,
  //     label: 'IGST',
  //     type: 'TAX',
  //     question: 'Is the IGST correct?',
  //     comment: ''
  //   },
  //   TOTAL: {
  //     status: '',
  //     validation: '',
  //     modifiedValue: 832742,
  //     originalValue: 832742,
  //     answer: 832742,
  //     accuracy: 99.96,
  //     label: 'Total',
  //     type: 'TOTAL',
  //     question: 'Is the Total correct?',
  //     comment: ''
  //   },
  //   INVOICE_RECEIPT_ID: {
  //     status: '',
  //     validation: '',
  //     modifiedValue: 'RA-20',
  //     originalValue: 'RA-19',
  //     answer: 'RA-19',
  //     accuracy: 94.56,
  //     label: 'Invoice No.',
  //     type: 'INVOICE_RECEIPT_ID',
  //     question: 'Is the Invoice No. correct?',
  //     comment: ''
  //   },
  //   INVOICE_RECEIPT_DATE: {
  //     status: '',
  //     validation: '',
  //     modifiedValue: '02.10.2023',
  //     originalValue: '02.10.2023',
  //     answer: '02.10.2023',
  //     accuracy: 98.37,
  //     label: 'Invoice Date',
  //     type: 'INVOICE_RECEIPT_DATE',
  //     question: 'Is the Invoice Date correct?',
  //     comment: ''
  //   }
  // }
};

// ** Reducer
const billValidation = createSlice({
  name: 'billValidation',
  initialState,
  reducers: {
    setBillValidation: (state, action) => {
      state.billValidateData = action.payload;
    }
  }
});

export const { setBillValidation } = billValidation.actions;

export default billValidation.reducer;
